import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function MunicipalitiesIcon({ className }: IconProps) {
  return (
    <svg
      width="101"
      height="101"
      viewBox="0 0 101 101"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2342)">
        <path
          d="M94.3564 86.0662L24.8693 100.817C20.3283 101.792 15.8787 98.8969 14.9339 94.3559L0.183151 24.8993C-0.792106 20.3583 2.10319 15.9087 6.64423 14.9639L76.1312 0.182662C80.6723 -0.792594 85.1219 2.1027 86.0667 6.64374L100.817 76.1308C101.793 80.6718 98.8974 85.1214 94.3564 86.0662Z"
          fill="#E8ECF7"
        />
        <path
          d="M50.9272 55.8331L44.2528 62.4161C43.7347 62.9342 43.7347 63.7571 44.2528 64.2752L55.4378 75.7954C55.9559 76.3135 56.7788 76.3135 57.2969 75.7954L63.8799 69.3344C64.398 68.8467 64.398 68.0239 63.9103 67.5058L52.8168 55.8636C52.3292 55.3455 51.4758 55.315 50.9577 55.8331"
          fill="#00C4B3"
        />
        <path
          d="M16.5191 84.6032C16.1534 84.6032 15.8181 84.4508 15.5439 84.207C15.0257 83.6584 15.0257 82.8051 15.5439 82.2565L74.3335 24.4421C74.8821 23.8935 75.7355 23.924 76.284 24.4421C76.8022 24.9907 76.8022 25.844 76.284 26.3926L17.4944 84.2375C17.2201 84.5118 16.8848 84.6337 16.5191 84.6337"
          fill="#00416B"
        />
        <path
          d="M46.5689 94.1427C46.2032 94.1427 45.8679 93.9903 45.5937 93.7465C45.0756 93.1979 45.0756 92.3446 45.5937 91.796L90.1202 47.9704C90.6688 47.4218 91.5221 47.4523 92.0707 47.9704C92.6193 48.519 92.5888 49.4028 92.0707 49.9209L47.5442 93.7465C47.2699 94.0208 46.9346 94.1427 46.5689 94.1427Z"
          fill="#00416B"
        />
        <path
          d="M8.56403 49.5552C8.19831 49.5552 7.86306 49.4333 7.58877 49.159C7.07067 48.6104 7.07067 47.7266 7.58877 47.2085L32.5492 22.6442C33.0978 22.0956 33.9512 22.1261 34.4998 22.6442C35.0483 23.1928 35.0179 24.0462 34.4998 24.5947L9.53929 49.159C9.265 49.4333 8.92975 49.5552 8.56403 49.5552Z"
          fill="#00416B"
        />
        <path
          d="M62.4469 90.6375C62.0812 90.6375 61.746 90.5156 61.4717 90.2413L3.90107 31.7564C3.35248 31.2078 3.38296 30.3544 3.90107 29.8059C4.44965 29.2573 5.303 29.2877 5.85158 29.8059L63.3917 88.2908C63.9098 88.8393 63.9098 89.6927 63.3917 90.2413C63.1174 90.5156 62.7822 90.6375 62.4165 90.6375"
          fill="#00416B"
        />
        <path
          d="M40.4434 95.6664C40.0777 95.6664 39.7425 95.5445 39.4682 95.2702L11.5819 66.9268C11.0638 66.3782 11.0638 65.4944 11.5819 64.9763C12.1305 64.4277 12.9839 64.4582 13.5325 64.9763L41.4187 93.2892C41.9368 93.8378 41.9368 94.6911 41.4187 95.2397C41.1444 95.514 40.8092 95.6359 40.4434 95.6359"
          fill="#00416B"
        />
        <path
          d="M86.1583 85.6397C85.7926 85.6397 85.4268 85.4873 85.1526 85.213L29.9591 27.2157C29.441 26.6672 29.4715 25.7833 30.0201 25.2652C30.5687 24.7471 31.4525 24.7471 31.9706 25.2957L87.164 83.293C87.6821 83.8416 87.6516 84.7254 87.1031 85.2435C86.8288 85.4873 86.4935 85.6092 86.1583 85.6092"
          fill="#00416B"
        />
        <path
          d="M93.7165 63.6352C93.3508 63.6352 92.9851 63.4828 92.7108 63.2085L44.1613 12.1904C43.6432 11.6418 43.6737 10.758 44.2222 10.2399C44.7708 9.72178 45.6546 9.75226 46.1727 10.2704L94.7222 61.2885C95.2403 61.8371 95.2099 62.7209 94.6613 63.239C94.387 63.5133 94.0517 63.6352 93.7165 63.6352Z"
          fill="#00416B"
        />
        <path
          d="M65.7388 40.5343L59.0644 47.1173C58.5463 47.6354 58.5463 48.4583 59.0644 48.9764L70.2493 60.4966C70.7674 61.0147 71.5903 61.0147 72.1084 60.4966L78.6914 54.0355C79.2095 53.5479 79.2095 52.725 78.7219 52.2069L67.6283 40.5648C67.1407 40.0467 66.2874 40.0162 65.7693 40.5343"
          fill="#00C4B3"
        />
        <path
          d="M45.2583 19.4137L38.5839 25.9967C38.0658 26.5148 38.0658 27.3377 38.5839 27.8558L49.7689 39.376C50.287 39.8941 51.1098 39.8941 51.6279 39.376L58.2109 32.9149C58.729 32.4273 58.729 31.6044 58.2414 31.0863L47.1479 19.4442C46.6602 18.9261 45.8069 18.8956 45.2888 19.4137"
          fill="#00C4B3"
        />
        <path
          d="M30.5679 33.9816L23.8935 40.5646C23.3754 41.0827 23.3754 41.9055 23.8935 42.4237L35.0784 53.9439C35.5965 54.462 36.4194 54.462 36.9375 53.9439L43.5205 47.4828C44.0386 46.9952 44.0386 46.1723 43.551 45.6542L32.4574 34.0121C31.9698 33.494 31.1165 33.4635 30.5983 33.9816"
          fill="#00C4B3"
        />
        <path
          d="M61.1362 5.6686L54.4618 12.2516C53.9437 12.7697 53.9437 13.5926 54.4618 14.1107L65.6468 25.6309C66.1649 26.149 66.9878 26.149 67.5059 25.6309L74.0889 19.1698C74.607 18.6822 74.607 17.8593 74.1193 17.3412L63.0258 5.69907C62.5382 5.18097 61.6848 5.15049 61.1667 5.6686"
          fill="#00C4B3"
        />
        <path
          d="M85.1216 60.862L78.4472 67.4449C77.9291 67.963 77.9291 68.7859 78.4472 69.304L89.6321 80.8242C90.1503 81.3423 90.9731 81.3423 91.4912 80.8242L98.0742 74.3632C98.5923 73.8755 98.5923 73.0527 98.1047 72.5346L87.0111 60.8924C86.5235 60.3743 85.6702 60.3439 85.1521 60.862"
          fill="#00C4B3"
        />
        <path
          d="M36.3286 70.1271L29.6542 76.7101C29.1361 77.2282 29.1361 78.0511 29.6542 78.5692L40.8392 90.0894C41.3573 90.6075 42.1802 90.6075 42.6983 90.0894L49.2812 83.6283C49.7993 83.1407 49.7993 82.3178 49.3117 81.7997L38.2182 70.1576C37.7305 69.6395 36.8772 69.609 36.3591 70.1271"
          fill="#00C4B3"
        />
        <path
          d="M7.55825 27.1547L14.1412 33.8291C14.6593 34.3472 15.4822 34.3472 16.0003 33.8291L27.5205 22.6441C28.0386 22.126 28.0386 21.3031 27.5205 20.785L21.0595 14.202C20.5718 13.6839 19.749 13.6839 19.2308 14.1716L7.58872 25.2651C7.07062 25.7527 7.04014 26.6061 7.55825 27.1242"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2342">
          <rect width="101" height="101" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
